// import {
//   OrbitControls,
//   OrthographicCamera,
//   PerspectiveCamera,
//   Text,
// } from "@react-three/drei";
import { Text } from "@react-three/drei";
import { useDispatch } from "react-redux";
import { Canvas, useLoader } from "@react-three/fiber";
import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import * as THREE from "three";
import { useSelector } from "react-redux";
import {
  IAMAxios,
  OnboardingAxios,
  ProgramSetupAxios,
  UserActivityAxios,
} from "../../API";
import ArtificialSatellite from "../../components/space/artificialSattelite";
import applicationApproved from "../../components/space/assets/img/application_approved.png";
// import globe from '../../components/space/assets/img/Planet.png';
import globe from "../../components/space/assets/img/Globe_Texture.jpg";
import Globe from "../../components/space/globeComponent";
import LeftGlobe from "../../components/space/leftGlobe";
//import ProgramInfoGlobe from "../../components/space/programInfoGlobe";
import RightGlobe from "../../components/space/rightGlobe";
import Ring from "../../components/space/ring";
import VideoGlobe from "../../components/space/videoGlobe";
import Avatar from "../../shared/commonComponents/Avatar";
import VideoPlayer from "../../shared/commonComponents/VideoPlayer/VideoPlayer";
import { ROLE } from "../../shared/Enum";
import { Checkbox, SelectDropdown, TextAreaInput, TextInput } from "../../shared/inputs";
import GradientButton from "../../shared/inputs/GradientButton";
import "./onboarding.module.css";
import SkillTrajectory from "./skillTrajectory";
import MiniGlobe from "./subComp/miniGlobe";
import MissionDirectors from "./subComp/MissionDirectors";
import videoImg from "../../components/space/assets/img/atro.png";
import playImg from "../../components/space/assets/img/3d_play_button.png";
import TourSlide from "../../components/Overlay/TourSlide";

import MiniGlobeItem from "./subComp/miniGlobeItem";
import RightGlobeStatic from "./subComp/rightGlobeStatic";
import LeftGlobeStatic from "./subComp/leftGlobeStatic";
import ArtGlobeStatic from "./subComp/artGlobeStatic";
import CdxModal from "../../shared/modal/CdxModal";
import CdxToolTip from "../../shared/CdxToolTip";
import ProgramSchedule from "./subComp/ProgramSchedule";
import authSlice from "../../store/auth/authSlice";

export default function Onboarding() {
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const [cameraFOV, setCameraFOV] = useState(100);
  const [cameraPosition, setCameraPosition] = useState([0, 2.5, 10]);
  const [globeTexture] = useLoader(THREE.TextureLoader, [globe]);
  const [videoTexture] = useLoader(THREE.TextureLoader, [videoImg]);
  const [playImgTexture] = useLoader(THREE.TextureLoader, [playImg]);
  const [startTour, setStartTour] = useState(false);

  const [approvedTexture] = useLoader(THREE.TextureLoader, [
    applicationApproved,
  ]);
  const [showCanvas, setShowCanvas] = useState(true);
  const [showProfileForm, setShowProfileForm] = useState(false);
  const [profilePage, setProfilePage] = useState(1);
  const [showVideo, setShowVideo] = useState(false);
  const [showEligible, setShowEligible] = useState(false);
  const [showProgramInfo, setShowProgramInfo] = useState(false);
  const [showLearning, setShowLearning] = useState(false);
  const [showMissionDirectors, setShowMissionDirectors] = useState(false);
  const [showSkillTrajectory, setShowSkillTrajectory] = useState(false);
  const [showPreLoadedSkillTrajectory, setShowPreLoadedSkillTrajectory] = useState(false);
  const [applicationBegin, setApplicationBegin] = useState(false);
  const [isApplicationApproved, setIsApplicationApproved] = useState(false);
  const [offeringUserData, setOfferingUserData] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [profilePageTwoSubmit, setProfilePageTwoSubmit] = useState(false);
  const [profilePageThreeSubmit, setProfilePageThreeSubmit] = useState(false);
  const [profilePageFourSubmit, setProfilePageFourSubmit] = useState(false);
  const [loader, setLoader] = useState(true);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);

  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  var offeringId = loggedInUser.offeringId;
  //to do find alternative to location.state sanitize for email 
  var email = loggedInUser.email;

  // var email = location.state.email;


  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  const [SAPUser, setSAPUser] = useState(null);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const regionsList = [{ value: 2, label: 'USI' }, { value: 1, label: 'US' }];

  const updateEligibleUserIds = (lUserId, lUserRoleId) => {
    if (lUserId && lUserRoleId) {
      var data = {
        offeringId: offeringId,
        email: email,
        userId: lUserId,
        userRoleId: lUserRoleId,
      };
      ProgramSetupAxios.put(`EligiblePool/updateuserdetails`, data)
        .then(function () { })
        .catch(function () { });
    }
  };

  const [selectedMission, setSelectedMission] = useState(null);
  useEffect(() => {
    ProgramSetupAxios.get(
      `/OfferingMission/getmissionsbyoffering/${offeringId}`
    )
      .then(function (response) {
        var temp = [...response.data];
        temp.forEach((element) => {
          element["isSelected"] = false;
        });

        setMissionList(temp);
      })
      .catch(function (error) {
        console.log(error);
      });

    localStorage.removeItem("userProfileDataLocal");
    dispatch(authSlice.actions.setCurrentOfferingId(offeringId));
    IAMAxios.get(`SAPUser/byemail/${email}`)
      .then(function (response) {
        var temp = JSON.parse(JSON.stringify(response.data));
        let reg = regionsList.filter((x) => x.label == temp.geography);
        if (reg.length > 0) {
          temp['geographyId'] = reg[0].value;
        }
        setSAPUser(temp);
        OnboardingAxios.get(
          `OfferingUsers/getofferinguserbyemail/${offeringId}/${email}/0`
        )
          .then(function (response) {
            if (response.data.onboardingCompleted) {
              history.push("/home");
            }
          })
          .catch(function (error) {
            console.log("error ::: ", error);
          });


      })
      .catch(function (error) {
        setLoader(false);
        console.log("error: " + error);
      });
  }, []);

  const [eligibleUser, setEligibleUser] = useState(null);
  const [eligibleErrorMsg, setEligibleErrorMsg] = useState(
    "You are currently not eligible for this program."
  );

  const [isDisableApply, setIsDisableApply] = useState(false);

  const applyForSpacePass = () => {
    var currentDate = new Date();
    if (isDisableApply) {
      return;
    }
    if (eligibleUser) {
      if (eligibleUser && eligibleUser.role === 5) {
        if (missionList.some((x) => x.coachRemainingSeats != 0)) {
          if (
            new Date(offeringDetails.coachRegStartDate) < currentDate &&
            currentDate < new Date(offeringDetails.coachRegEndDate)
          ) {
            setProfilePage(1);
            setShowProfileForm(true);
            setShowCanvas(false);
          } else {
            setEligibleErrorMsg(
              `Coach registrations for this program will start on ${getParsedDate(
                offeringDetails.coachRegStartDate
              )}. Please visit this site on or after this date to complete your registration.`
            );
            setShowEligible(true);
          }
        } else {
          setEligibleErrorMsg(
            `Coach seats are full. Please check with management team.`
          );
          setShowEligible(true);
        }
      } else {
        if (missionList.some((x) => x.learnerRemainingSeats != 0)) {
          if (
            new Date(offeringDetails.learnerRegStartDate) < currentDate &&
            currentDate < new Date(offeringDetails.learnerRegEndDate)
          ) {
            setProfilePage(1);
            setShowProfileForm(true);
            setShowCanvas(false);
          } else {
            setEligibleErrorMsg(
              `Registrations for this program will open on ${getParsedDate(
                offeringDetails.learnerRegStartDate
              )}. Please apply on or after this date to get your space pass`
            );
            setShowEligible(true);
          }
        } else {
          setEligibleErrorMsg(
            `Learner seats are full. Please check with management team.`
          );
          setShowEligible(true);
        }
      }
    } else {
      setShowEligible(true);
      setIsDisableApply(true);
    }
  };

  const getParsedDate = (strDate) => {
    var strSplitDate = String(strDate).split(" ");
    var date = new Date(strSplitDate[0]);
    var dd = date.getDate();
    var mm = date.getMonth() + 1; //January is 0!
    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    date = dd + "-" + mm + "-" + yyyy;
    return date.toString();
  };

  const contactProgramManager = () => {
    window.open("mailto:usitcdp@deloitte.com");
  };

  const [artificialSateTextPosition, setArtificialSateTextPosition] = useState([
    2, 1, 3,
  ]);
  const [artificialSatePosition, setArtificialSatePosition] = useState([
    1.5, 0, 3,
  ]);
  const [leftGlobePosition, setLeftGlobePosition] = useState([-6.2, 2.4, 4]);
  const [globePosition, setGlobePosition] = useState([0, 2, 0]);
  const [rightGlobePosition, setRightGlobePosition] = useState([5.3, 2.4, 4]);
  const [videoPosition, setVideoPosition] = useState([0, 2, 7.5]);
  const [ringPosition, setRingPosition] = useState([0, 2, 0]);
  // const [programInfoGlobePosition, setProgramInfoGlobePosition] = useState([
  //   -15, -8, 0,
  // ]);
  const [approveIconPosition, setApproveIconPosition] = useState([0, 2.2, 8]);
  const [isCameraUpdated, setIsCameraUpdated] = useState(false);
  const [globeScale, setGlobeScale] = useState([5, 5, 5]);
  const [videoGlobeScale, setVideoGlobeScale] = useState([1, 1, 1]);
  const resetPositions = () => {
    setIsCameraUpdated(false);
    setApproveIconPosition([0, 2, 8]);
    setArtificialSatePosition([1.5, 0, 3]);
    setArtificialSateTextPosition([2, 1, 3]);
    setLeftGlobePosition([-6.2, 2.4, 4]);
    setGlobePosition([0, 2, 0]);
    setRightGlobePosition([5.3, 2.4, 4]);
    setVideoPosition([0, 2, 7.5]);
    setRingPosition([0, 2, 0]);
    setGlobeScale([5, 5, 5]);
    setVideoGlobeScale([1, 1, 1]);
    // setCameraPosition([0, 1, 15])
  };
  const movePositions = () => {
    setIsCameraUpdated(true);
    setApproveIconPosition([0, 11, 8]);
    setArtificialSatePosition([0, 11, 0]);
    setLeftGlobePosition([-6.2, 11.3, 4]);
    setGlobePosition([0, 11, 0]);
    setRightGlobePosition([5.3, 11.3, 4]);
    setVideoPosition([0, 11, 7.5]);
    setRingPosition([0, 11, 0]);
    setGlobeScale([5, 4.2, 5]);
    setVideoGlobeScale([1, 0.8, 1]);
    // setCameraPosition([0, 5, 10])
    // setProgramInfoGlobePosition([-15, -6, 0 ])
  };
  const showProgramInfoHandler = () => {
    if (showProgramInfo) {
      resetPositions();
    } else {
      movePositions();
    }
    setShowProgramInfo(!showProgramInfo);
    setShowLearning(false);
  };
  const setShowLearningHandler = () => {
    if (showLearning) {
      resetPositions();
    } else {
      movePositions();
    }
    setShowLearning(!showLearning);
    setShowProgramInfo(false);
  };

  const [userProfileDataLocal, setUserProfileDataLocal] = useState(null);
  const [userData, setUserData] = useState(null);
  const [offeringDetails, setOfferingDetails] = useState(null);
  const [missionList, setMissionList] = useState([]);
  const [offeringLinks, setOfferingLinks] = useState([]);
  const [connectLinks, setConnectLinks] = useState([]);
  const [ownLinks, setOwnLinks] = useState([]);
  const [solveLinks, setSolveLinks] = useState([]);
  const [communicateLinks, setCommunicateLinks] = useState([]);
  const [deanData, setDeanData] = useState(null);
  const [videoLink, setVideoLink] = useState([]);

  const [offeringList, setOfferingList] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [geographyList, setGeographyList] = useState([]);

  useEffect(() => {
    ProgramSetupAxios.get(`OfferingLink/getofferinglinks/${offeringId}`)
      .then(function (response) {
        setOfferingLinks(response.data);
        let tempConnect = response.data.filter((x) => x.linkType == 5);
        let tempOwn = response.data.filter((x) => x.linkType == 6);
        let solve = response.data.filter((x) => x.linkType == 7);
        let Communicate = response.data.filter((x) => x.linkType == 8);
        let videoLink = response.data.filter((x) => x.linkType == 9);

        setConnectLinks(tempConnect);
        setOwnLinks(tempOwn);
        setSolveLinks(solve);
        setCommunicateLinks(Communicate);
        setVideoLink(videoLink);
        counter++;
        if (counter >= 2) {
          setLoader(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    let counter = 0;
    getUsersByRole(ROLE.coach);
    ProgramSetupAxios.get(
      `EligiblePool/checkifeligible?offeringId=${offeringId}&emailId=${email}`
    )
      .then(function (response) {
        if (
          response.data !== "" &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setEligibleUser(response.data);
          let tempUser = response.data;
          setIsApplicationApproved(response.data.isApproved);
          ProgramSetupAxios.get(`Offering/getoffering/${offeringId}`)
            .then(function (response) {
              const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ];
              const d = new Date(response.data.startDate);
              setOfferingMonth(monthNames[d.getMonth()].toUpperCase());
              setOfferingDay(d.getDate());
              setOfferingYear(d.getFullYear());
              setOfferingDetails(response.data);

              var currentDate = new Date();

              if (tempUser.role == 4) {
                setRegistrationEndDate(response.data.learnerRegEndDate);
                if (currentDate > new Date(response.data.learnerRegEndDate)) {
                  setIsDisableApply(true);
                }
              }

              if (tempUser.role == 5) {
                setRegistrationEndDate(response.data.coachRegEndDate);
                if (currentDate > new Date(response.data.coachRegEndDate)) {
                  setIsDisableApply(true);
                }
              }

              setDeanData({
                firstName: response.data.deanFirstName,
                lastName: response.data.deanLastName,
                email: response.data.deanEmail,
                profileImage: response.data.deanProfileImage,
                deanBrief: response.data.deanBrief,
              });
              counter++;
              if (counter >= 2) {
                setLoader(false);
              }
            })
            .catch(function (error) {
              console.log("error: " + error);
            });

          if (!response.data.isApproved) {

            IAMAxios.get(`User/byemail/${email}`)
              .then(function (response) {

                OnboardingAxios.get("UserProfile/getuserprofile/" + response.data.id + "/" + offeringId)
                  .then(function (response) {
                    setUserProfileDataLocal(response.data.userProfileMetaData);
                  })
                  .catch(function (error) {
                    console.log("error: " + error);
                  });

                var temp = JSON.parse(JSON.stringify(response.data));
                let reg = regionsList.filter((x) => x.label == temp.geography);
                if (reg.length > 0) {
                  temp['geographyId'] = reg[0].value;
                }
                setSAPUser(temp);
                setProfilePictureUrl(response.data.profileImage);
                setProfilePictureFile(response.data.profileImage);
                setUserData(response.data);

                if (tempUser.userId != 0) {
                  if (tempUser.preferredMission != 0) {
                    setApplicationBegin(true);
                  } else {
                    setShowProfileForm(false);
                    setShowCanvas(true);
                    setShowMissionSelection(true);
                    movePositions();
                  }
                }
              })
              .catch(function (error) {
                console.log("error: " + error);
              });

            OnboardingAxios.get(`UserProfile/getprofilemetadata/${offeringId}`)
              .then(function (response) {
                setUserProfileDataLocal(response.data);
              })
              .catch(function (error) {
                console.log("error: " + error);
              });

          } else {
            if (response.data.userId != 0) {
              OnboardingAxios.get(
                `OfferingUsers/getofferinguserbyemail/${offeringId}/${email}/0`
              )
                .then(function (response) {
                  setOfferingUserData(response.data);

                  if (response.data.onboardingCompleted) {
                    history.push("/home");
                  } else {
                    setIsApplicationApproved(true);
                    OnboardingAxios.get(
                      `OfferingUsers/getmyteamconnections/${response.data.offeringUserId}`
                    )
                      .then(function (response) {
                        setTeamMembers(response.data);
                      })
                      .catch(function (error) {
                        console.log("error ::: ", error);
                      });
                  }
                })
                .catch(function (error) {
                  console.log("error ::: ", error);
                });
            }
          }
        } else {
          ProgramSetupAxios.get(`Offering/getoffering/${offeringId}`)
            .then(function (response) {
              const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ];
              const d = new Date(response.data.startDate);
              setOfferingMonth(monthNames[d.getMonth()].toUpperCase());
              setOfferingDay(d.getDate());
              setOfferingYear(d.getFullYear());
              setOfferingDetails(response.data);
              var currentDate = new Date();
              setRegistrationEndDate(response.data.coachRegEndDate);
              if (currentDate > new Date(response.data.coachRegEndDate)) {
                setIsDisableApply(true);
              }
              setDeanData({
                firstName: response.data.deanFirstName,
                lastName: response.data.deanLastName,
                email: response.data.deanEmail,
                profileImage: response.data.deanProfileImage,
                deanBrief: response.data.deanBrief,
              });

            })
            .catch(function (error) {
              console.log("error: " + error);
            });
          setLoader(false);
        }
      })
      .catch(function (error) {
        console.log("You are currently not eligible for this program.");
      });
  }, []);

  useEffect(() => {
    if (scrollRef.current != null) {
      scrollRef.current.scrollIntoView();
    }
  }, [profilePageTwoSubmit, profilePageThreeSubmit]);

  const handleFieldChange = (e, field) => {
    console.log(field);
    console.log(e.target.value);
    var temp = JSON.parse(JSON.stringify(userProfileDataLocal));
    var index = temp
      .map(function (k) {
        return k.value;
      })
      .indexOf(field);
    temp[index]["answer"] = e.target.value;
    setUserProfileDataLocal(temp);
  };

  const handleProfileData = (field, e) => {
    var temp = JSON.parse(JSON.stringify(SAPUser));
    temp[field] = e.target.value;
    setSAPUser(temp);
  };

  const handleRegionChange = (e) => {
    var temp = JSON.parse(JSON.stringify(SAPUser));
    let reg = regionsList.find((x) => x.value == e.target.value);
    temp['geographyId'] = reg.value;
    temp['geography'] = reg.label;
    setSAPUser(temp);
  };

  const handleCheckBoxChange = (e, item, option, optionIndex) => {
    var localFlag = e.target.checked;
    var temp = JSON.parse(JSON.stringify(userProfileDataLocal));
    var index = temp
      .map(function (k) {
        return k.value;
      })
      .indexOf(item.value);
    var tempStr = [];
    if (temp[index]["answer"]) tempStr = temp[index]["answer"].split(",");
    if (item.valueType === 3) {
      var options = JSON.parse(temp[index]["options"]);
      options[optionIndex].forEach((option) => {
        var strIndex = tempStr.indexOf(option);
        if (strIndex >= 0) tempStr.splice(strIndex, 1);
      });
      if (localFlag) {
        tempStr.push(option);
      }
    } else {
      if (localFlag) tempStr.push(option);
      else {
        var strIndex = tempStr.indexOf(option);
        tempStr.splice(strIndex, 1);
      }
    }
    temp[index]["answer"] = tempStr.join();
    setUserProfileDataLocal(temp);
  };

  const nextPageHandler = () => {
    if (
      SAPUser.firstName == "" ||
      SAPUser.lastName == "" ||
      SAPUser.portfolio == "" ||
      SAPUser.location == "" ||
      SAPUser.industry == "" ||
      SAPUser.offering == ""
    ) {
      setProfilePage(2);
      return;
    }
    if (profilePage === 4) {
      setProfilePageFourSubmit(true);
      let tmp = userProfileDataLocal.filter(
        (x) =>
          x.category === "Communities of Interest" &&
          (x.answer == "" || x.answer == null || x.answer == undefined)
      );
      if (tmp.length > 0) {
        return;
      }
      updateProfile();
      setShowProfileForm(false);
      setShowCanvas(true);
      setShowMissionSelection(true);
      movePositions();
    } else {
      if (profilePage === 2) {
        setProfilePageTwoSubmit(true);
        let tmp = userProfileDataLocal.filter(
          (x) =>
            x.category === "Basic Profile" &&
            (x.answer == "" || x.answer == null || x.answer == undefined)
        );
        if (tmp.length > 0) {
          return;
        }
      }

      if (profilePage === 3) {
        setProfilePageThreeSubmit(true);
        let tmp = userProfileDataLocal.filter(
          (x) =>
            x.category === "About me" &&
            (x.answer == "" || x.answer == null || x.answer == undefined)
        );
        if (tmp.length > 0) {
          return;
        }
      }
      var temp = profilePage + 1;
      setProfilePage(temp);
    }
  };
  const previousPageHandler = () => {
    if (
      SAPUser.firstName == "" ||
      SAPUser.lastName == "" ||
      SAPUser.portfolio == "" ||
      SAPUser.location == "" ||
      SAPUser.industry == "" ||
      SAPUser.offering == ""
    ) {
      setProfilePage(2);
      return;
    }
    var temp = profilePage - 1;
    setProfilePage(temp);
  };

  const updateProfile = () => {
    if (
      SAPUser.firstName == "" ||
      SAPUser.lastName == "" ||
      SAPUser.portfolio == "" ||
      SAPUser.location == "" ||
      SAPUser.industry == "" ||
      SAPUser.offering == ""
    ) {
      setProfilePage(2);
      return;
    }
    //create user using SAP User and then create user profile
    var newFormData = new FormData();
    newFormData.set("firstName", SAPUser.firstName);
    newFormData.set("lastName", SAPUser.lastName);
    newFormData.set("email", SAPUser.email);
    newFormData.set("portfolio", SAPUser.portfolio);
    newFormData.set("offering", SAPUser.offering);
    newFormData.set("location", SAPUser.location);
    newFormData.set("industry", SAPUser.industry);
    newFormData.set("geography", SAPUser.geography);
    if (SAPUser.geographyId)
      newFormData.set("geographyId", SAPUser.geographyId);
    else
      newFormData.set("geographyId", 2);

    newFormData.set("jobLevel", SAPUser.jobLevel);

    if (
      profilePictureFile !== null ||
      profilePictureFile !== "" ||
      profilePictureFile !== undefined
    ) {
      newFormData.append("profileImage", profilePictureFile);
    }

    //add user role
    newFormData.set("roles", [eligibleUser.role]);
    if (!userData) {
      IAMAxios.post("User", newFormData)
        .then(function (response) {
          console.log(response);
          setUserData(response.data);

          updateEligibleUserIds(
            response.data.id,
            response.data.userRoles[0].userRoleId
          );
          var dataList = [];
          userProfileDataLocal.forEach((element) => {
            var data = {
              offeringId: offeringId,
              userId: response.data.id,
              profileKey: element.profileKey,
              answer: element.answer,
            };
            dataList.push(data);
          });
          var requestData = {
            requestModel: dataList,
            message: messagePoint,
            isBackgroundJob: false,
          };
          sessionStorage.setItem(
            "userProfileDataLocal",
            JSON.stringify(userProfileDataLocal)
          );
          OnboardingAxios.put("UserProfile/updateuserprofile", requestData)
            .then(function (response) { })
            .catch(function (error) {
              console.log("error: " + error);
            });
          var dataOffering = {
            offeringId: offeringId,
            coachRemainingSeats: offeringDetails.coachRemainingSeats,
            learnerRemainingSeats: offeringDetails.learnerRemainingSeats,
          };
          if (eligibleUser.role === 5) {
            dataOffering.coachRemainingSeats =
              offeringDetails.coachRemainingSeats - 1;
          } else {
            dataOffering.learnerRemainingSeats =
              offeringDetails.learnerRemainingSeats - 1;
          }
        })
        .catch(function (error) {
          console.log("error: " + error);
        });
    } else {
      IAMAxios.put("User/updateuser", newFormData)
        .then(function (response) {

          updateEligibleUserIds(
            userData.id,
            userData.userRoles[0].userRoleId
          );
          var dataList = [];
          userProfileDataLocal.forEach((element) => {
            var data = {
              offeringId: offeringId,
              userId: response.data.id,
              profileKey: element.profileKey,
              answer: element.answer,
            };
            dataList.push(data);
          });
          var requestData = {
            requestModel: dataList,
            message: messagePoint,
            isBackgroundJob: false,
          };
          sessionStorage.setItem(
            "userProfileDataLocal",
            JSON.stringify(userProfileDataLocal)
          );
          OnboardingAxios.put("UserProfile/updateuserprofile", requestData)
            .then(function (response) { })
            .catch(function (error) {
              console.log("error: " + error);
            });

        })
        .catch(function (error) {
          console.log("error: " + error);
        });
      var dataList = [];
      userProfileDataLocal.forEach((element) => {
        var data = {
          offeringId: offeringId,
          userId: userData.id,
          profileKey: element.profileKey,
          answer: element.answer,
        };
        dataList.push(data);
      });
      var requestData = {
        requestModel: dataList,
        message: messagePoint,
        isBackgroundJob: false,
      };
      OnboardingAxios.put("UserProfile/updateuserprofile", requestData)
        .then(function (response) { })
        .catch(function (error) {
          console.log("error: " + error);
        });
    }
  };

  const [registrationEndDate, setRegistrationEndDate] = useState(null);
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  function calculateTimeLeft() {
    const year = new Date().getFullYear() + 1;
    let difference = 0;
    if (registrationEndDate) {
      difference = +new Date(registrationEndDate) - +new Date();
    } else {
      difference = +new Date(`${year}-10-1`) - +new Date();
    }

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }

  useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  const timerComponents = Object.keys(timeLeft).map((interval, index) => {
    return (
      <span className="timer-width" key={`retbn${index}`}>
        {pad(timeLeft[interval]) === 0 ? "00" : pad(timeLeft[interval])}
      </span>
    );
  });
  function pad(n) {
    return n < 10 ? "0" + n : n;
  }

  const [showMissionSelection, setShowMissionSelection] = useState(false);
  const [offeringMonth, setOfferingMonth] = useState(null);
  const [offeringDay, setOfferingDay] = useState(null);
  const [offeringYear, setOfferingYear] = useState(null);

  const setMissionSelected = (item) => {
    if (eligibleUser.role == 5 && item.coachRemainingSeats != 0) {
      setSelectedMission(item);
    }
    if (eligibleUser.role != 5 && item.learnerRemainingSeats != 0) {
      setSelectedMission(item);
    }
    setShowSkillPopup(true);
  };

  const exitSkillTrajectory = () => {
    setShowSkillPopup(false);

    setShowCanvas(false);
    setTimeout(() => {
      resetPositions();
      setShowMissionSelection(false);
      setShowProfileForm(false);
      setShowCanvas(true);
      setShowSkillTrajectory(false);
      setApplicationBegin(true);
      var missionData = {
        missionId: selectedMission.id,
        offeringId: offeringId,
        email: email,
      };
      ProgramSetupAxios.put(`EligiblePool/updatemission`, missionData)
        .then(function (response) {
          var data = {
            id: selectedMission.id,
            coachSeat: selectedMission.coachRemainingSeats,
            learnerSeat: selectedMission.learnerRemainingSeats,
          };
          if (eligibleUser.role === 5) {
            data.coachSeat = data.coachSeat - 1;
          } else {
            data.learnerSeat = data.learnerSeat - 1;
          }
          ProgramSetupAxios.put("OfferingMission/updatemissionseats", data)
            .then(function (response) { })
            .catch(function (error) {
              console.log("error: " + error);
            });
        })
        .catch(function (error) { });
    }, 1000);
  };

  const redirectToSkillTrajectory = () => {
    setShowSkillPopup(false);
    if (selectedMission) {
      setShowMissionSelection(false);
      setShowProfileForm(false);
      setShowCanvas(false);
      setShowSkillTrajectory(true);

    }

  };

  const redirectToProfile = () => {
    let userProfileData = sessionStorage.getItem("userProfileDataLocal");
    userProfileData = JSON.parse(userProfileData);
    setShowMissionSelection(false);
    setProfilePage(2);
    setShowProfileForm(true);
    setShowCanvas(false);
  };

  const launchApp = () => {
    OnboardingAxios.get(
      `OfferingUsers/setonboardingcompleted/${offeringUserData.offeringUserId}`
    )
      .then(function (response) {
        history.push("/home");
      })
      .catch(function (error) {
        console.log("error ::: ", error);
      });
  };

  const [coachList, setCoachList] = useState([]);
  const getUsersByRole = (roleId) => {
    IAMAxios.get(`User/getusersbyrole/${roleId}`)
      .then(function (response) {
        setCoachList(response.data);
        const industryList = [
          "All",
          ...new Set(response.data.map((item) => item.industry)),
        ];
        const geographyList = [
          "All",
          ...new Set(response.data.map((item) => item.geography)),
        ];
        const offeringList = [
          "All",
          ...new Set(response.data.map((item) => item.offering)),
        ];
        setIndustryList(industryList);
        setGeographyList(geographyList);
        setOfferingList(offeringList);
      })
      .catch(function (error) {
        console.log("User/getusersbyrole :: ", error);
      });
  };

  const uploadProfilePicture = () => {
    document.getElementById("uploadProfilePicture").click();
  };

  const [profilePictureFile, setProfilePictureFile] = useState(null);
  const [profilePictureName, setProfilePictureName] = useState("");
  const [profilePictureErrorText, setProfilePictureErrorText] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const profilePictureSelectHandler = async (file) => {
    let currentFile = Array.from(file.target.files);
    if (currentFile && currentFile.length > 0) {
      if (!currentFile[0].type.includes("image")) {
        setProfilePictureErrorText(
          "Only image files less than 2MB size are supported"
        );
        return;
      }
      const fileSize = Math.round(currentFile[0].size / 1024);
      if (fileSize >= 2049) {
        setProfilePictureErrorText(
          "Profile picture size exceeds the max limit of 2MB."
        );
        return;
      } else {
        setProfilePictureErrorText("");
      }

      setProfilePictureName(currentFile[0].name);
      setProfilePictureFile(currentFile[0]);
      setProfilePictureUrl(URL.createObjectURL(currentFile[0]));
    }
  };

  const removeProfilePicture = () => {
    setProfilePictureFile("");
  };

  const [showSkillPopup, setShowSkillPopup] = useState(false);


  const openIntroVideo = () => {
    setShowVideo(true);

    var UAdata = {
      email: email,
      offeringId: offeringId,
      missionId: 0,
      userId: userData ? userData.id : 0,
      offeringUserId: 0,
      actionType: "Onboarding",
      actionName: "Intro Video",
      actionOn: "",
    };
    UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

    }).catch(function (error) {
      console.log(error);
    });
  };

  const openHelp = () => {
    setStartTour(!startTour);
    var UAdata = {
      email: email,
      offeringId: offeringId,
      missionId: 0,
      userId: userData ? userData.id : 0,
      offeringUserId: 0,
      actionType: "Onboarding",
      actionName: "Help - Onboarding",
      actionOn: "",
    };
    UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

    }).catch(function (error) {
      console.log(error);
    });
  };


  const openLerarningLink = (item) => {
    var UAdata = {
      email: email,
      offeringId: offeringId,
      missionId: 0,
      userId: userData ? userData.id : 0,
      offeringUserId: 0,
      actionType: "Onboarding",
      actionName: "Learning Links",
      actionOn: item.displayName,
    };
    UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

    }).catch(function (error) {
      console.log(error);
    });
  };


  return (
    <>
      {loader && (
        <div className="loader-div">
          <div>Loading...</div>
        </div>
      )}
      {!loader && (
        <div
          className={
            showSkillTrajectory === true
              ? "onboarding-body position-relative"
              : "onboarding-body"
          }
        >
          {(applicationBegin ||
            showMissionSelection ||
            isApplicationApproved) && (
              <div
                className={
                  showMissionSelection
                    ? "onboarding-frame-background background-mission-select"
                    : "onboarding-frame-background "
                }
              ></div>
            )}
          <div
            className={
              showSkillTrajectory === true
                ? "onboarding-header onboarding-header-with-self-reflection"
                : "onboarding-header"
            }
          >
            <div
              className="logo-image"
              onClick={() => {
                setShowCanvas(!showCanvas);
                
              }}
            >
              {" "}
            </div>
            {/* <div className="onboarding-header-icons">
              <CdxToolTip trigger={['hover', 'focus']} content={"Help"}>
                <div className="onboarding-header-help" style={{ zIndex: startTour ? "1061" : "" }} onClick={openHelp} />
              </CdxToolTip>
            </div> */}
          </div>

          {applicationBegin && (
            <div className="onboarding-application-container">
              <div className="onboarding-application-starts">
                <div>Congratulations on registering for the program. You have successfully embarked on your Explore journey. Watch this space for the instructions regarding the next steps of the program.</div>
              </div>
            </div>
          )}
          {showCanvas && (
            <>
              <Canvas
                camera={{
                  position: isCameraUpdated ? [0, 11, 14] : cameraPosition,
                  fov: cameraFOV,
                }}
              >
                {/* <OrbitControls /> */}

                {/* <ambientLight intensity={0.5} />
                <spotLight position={[30, 30, 0]} castShadow /> */}
                <spotLight position={[15, 30, 15]} castShadow decay={0.5} />
                <spotLight position={[5, 30, 25]} castShadow />
                {/* <spotLight position={[30, 0, 0]} castShadow /> */}

                <ArtificialSatellite
                  position={artificialSatePosition}
                  textposition={artificialSateTextPosition}
                  onclick={showProgramInfoHandler}
                />
                {!showMissionSelection && (
                  <LeftGlobe
                    position={leftGlobePosition}
                    onclick={setShowMissionDirectors}
                  />
                )}
                <Globe
                  position={globePosition}
                  texture={globeTexture}
                  scale={globeScale}
                />
                {!showMissionSelection && (
                  <RightGlobe
                    position={rightGlobePosition}
                    onclick={setShowLearningHandler}
                  />
                )}
                {!applicationBegin && !isApplicationApproved && (
                  <VideoGlobe
                    autoplay
                    position={videoPosition}
                    buttonPress={openIntroVideo}
                    texture={videoTexture}
                    texture1={playImgTexture}
                    scale={videoGlobeScale}
                  />
                )}

                {isApplicationApproved && (
                  <>
                    <mesh position={approveIconPosition}>
                      <planeBufferGeometry attach="geometry" args={[2, 2]} />
                      <meshBasicMaterial
                        attach="material"
                        map={approvedTexture}
                        opacity={1}
                        transparent
                      />
                      <Text
                        color={"#00AEFF"}
                        fontSize={0.13}
                        maxWidth={100}
                        lineHeight={1}
                        letterSpacing={0.02}
                        textAlign={"left"}
                        position={[0, 0, 0.01]}
                        overflowWrap="break-word"
                        whiteSpace="overflowWrap"
                      >
                        Application approved
                      </Text>
                    </mesh>
                  </>
                )}
                <Ring position={ringPosition} />

              </Canvas>

              {showLearning && (
                <div className="parent-learning-layout">
                  <div className="learning-layout ">
                    {connectLinks && connectLinks.length > 0 && (
                      <div className="mini-globe-content">
                        <div className="mini-globe-ring">
                          <MiniGlobe item={connectLinks} openLerarningLink={openLerarningLink} />
                          <div className="mini-globe planet-1"></div>
                        </div>
                        <div className="mini-globe-link"></div>
                        <div className="mini-globe-name">Connect</div>
                      </div>
                    )}

                    {ownLinks && ownLinks.length > 0 && (
                      <div className="mini-globe-content">
                        <div className="mini-globe-ring">
                          <MiniGlobe item={ownLinks} openLerarningLink={openLerarningLink} />
                          <div className="mini-globe planet-2"></div>
                        </div>
                        <div className="mini-globe-link"></div>
                        <div className="mini-globe-name">Own</div>
                      </div>
                    )}

                    {solveLinks && solveLinks.length > 0 && (
                      <div className="mini-globe-content">
                        <div className="mini-globe-ring">
                          <MiniGlobe item={solveLinks} openLerarningLink={openLerarningLink} />
                          <div className="mini-globe planet-3"></div>
                        </div>
                        <div className="mini-globe-link"></div>
                        <div className="mini-globe-name">Solve</div>
                      </div>
                    )}

                    {communicateLinks && communicateLinks.length > 0 && (
                      <div className="mini-globe-content">
                        <div className="mini-globe-ring">
                          <MiniGlobe item={communicateLinks} openLerarningLink={openLerarningLink} />
                          <div className="mini-globe planet-4"></div>
                        </div>
                        <div className="mini-globe-link"></div>
                        <div className="mini-globe-name">Communicate</div>
                      </div>
                    )}

                    <div className="min-globe-col-close">
                      <div
                        className="modal-close-btn"
                        onClick={() => {
                          setShowLearningHandler();
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              )}
              {!showProgramInfo &&
                !showLearning &&
                !showMissionSelection &&
                !applicationBegin && (
                  <div className="apply-btn-wrapper">
                    {!isApplicationApproved && (
                      <>
                        <GradientButton
                          text="Apply for Space Pass"
                          className={
                            isDisableApply ? "apply-btn disabled" : "apply-btn"
                          }
                          onClick={applyForSpacePass}
                        />

                      </>
                    )}
                    {isApplicationApproved && (
                      <GradientButton
                        text="Launch"
                        className="apply-btn"
                        onClick={launchApp}
                      />
                    )}
                  </div>
                )}

              {!showMissionSelection && !isApplicationApproved && (
                <div className="onboarding-timer-opsition">
                  <div
                    className={
                      applicationBegin
                        ? "onboarding-timer-wrapper-application-begin"
                        : "onboarding-timer-wrapper"
                    }
                  >
                    <div className="onboarding-timer-label">
                      <span>----DAYS</span>
                      <span>---HOURS</span>
                      <span>--MINUTES</span>
                      <span>-SECONDS</span>
                    </div>
                    <div className="onboarding-timer-value">
                      {timerComponents.length ? (
                        timerComponents
                      ) : (
                        <span>Time's up!</span>
                      )}
                      <div className="timer-bottom-border"></div>
                    </div>
                    <div className="onboarding-timer-msg">
                      <span>Time left for applying for space pass</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {showProgramInfo && (
            <div className="parent-program-info">
              <div className="program-info-wrapper">
                <div className="program-info-col-1 ps-5 pe-5 ">
                  <div className="program-info-label">
                    <span className="px-3 py-2">
                      <nobr>The adventure begins on</nobr>
                    </span>
                  </div>
                  <div className="program-info-date">
                    <div className="program-info-calendar"></div>
                    <div className="program-info-dateTime">
                      <div>{offeringMonth}</div>
                      <div>
                        {offeringDay}-{offeringYear}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="program-info-col-2  program-outline">
                  <div className="program-info-col-close">
                    <div
                      className="modal-close-btn"
                      onClick={() => {
                        showProgramInfoHandler();
                      }}
                    />
                  </div>
                  <div className="program-info-col-1 ">
                    <span className="program-info-heading">
                      Programme Outline:
                    </span>
                  </div>
                  <div className="program-info-col-1 mb-3">
                    {offeringDetails && (
                      <span className="program-info-desc">
                        {offeringDetails.shortDescription}
                      </span>
                    )}
                  </div>
                  <div className="program-info-col-1">
                    <ProgramSchedule offeringId={offeringId} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {showMissionSelection && missionList && missionList.length > 0 && (
            <div className="mission-selection-div">
              <div className="mission-selection-wrapper">
                {missionList
                  .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
                  .map((item, index) => {
                    return (
                      <>
                        <div
                          key={`mission${index}`}
                          className="mission-selection-item mission-selection-item-border"
                        >
                          <div className="mission-selection-missionname ">
                            <div className="onboarding-corner-border px-3">
                              {item.missionName}
                            </div>
                          </div>
                          <div className="mission-selection-remaining">
                            {eligibleUser && eligibleUser.role === 5 && (
                              <span>
                                Seat{item.coachRemainingSeats <= 1 ? "" : "s"}{" "}
                                left - <span>{item.coachRemainingSeats}</span>
                              </span>
                            )}
                            {eligibleUser && eligibleUser.role !== 5 && (
                              <span>
                                Seat{item.learnerRemainingSeats <= 1 ? "" : "s"}{" "}
                                left - <span>{item.learnerRemainingSeats}</span>
                              </span>
                            )}
                          </div>
                          <div className="mission-selection-icon">
                            {item.imagePath && (
                              <img src={item.imagePath} alt="test"></img>
                            )}
                            {!item.imagePath && (
                              <img
                                src={
                                  item.sequence === 2
                                    ? "./space/img/Mission.png"
                                    : "./space/img/mission_default.png"
                                }
                                alt="test"
                              ></img>
                            )}
                          </div>
                          <div className="mission-selection-desc">
                            {item.shortDescription}
                          </div>

                          <div className="mission-selection-btn">
                            <button
                              disabled={
                                eligibleUser.role == 5
                                  ? item.coachRemainingSeats == 0
                                    ? true
                                    : false
                                  : item.learnerRemainingSeats == 0
                                    ? true
                                    : false
                              }
                              onClick={() => {
                                setMissionSelected(item);
                              }}
                              className={
                                selectedMission && item.id == selectedMission.id
                                  ? "mission-btn-clicked cdx-btn"
                                  : "cdx-btn"
                              }
                            >
                              Select Mission
                            </button>
                            <button
                              className=" cdx-btn"
                              onClick={() => {
                                setShowAdditionalInfo(true);
                                setAdditionalInfo(item);
                              }}
                            >
                              Additional Info
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
              <div className="mission-selection-btns left">
                <GradientButton
                  text="Profile"
                  className="gradient-button-reverse profile-btn"
                  onClick={() => {
                    redirectToProfile();
                  }}
                />
              </div>
            </div>
          )}

          {eligibleUser &&
            isApplicationApproved &&
            teamMembers &&
            teamMembers.length > 0 && (
              <div className="onboarding-team-wrapper">
                <div className="onboarding-team-title">
                  <span>Team</span>
                </div>
                <div className="px-2 w-100 max-h66 scroll-content">
                  {teamMembers.map((item, index) => {
                    return (
                      <div
                        className="onboarding-team-member"
                        key={`oirtb${index}`}
                      >

                        <div className="onboarding-profile-avatar">
                          <Avatar {...item} className="medium" />
                        </div>
                        <span className="onboarding-profile-username">
                          {item.firstName} {item.lastName}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

          {showProfileForm && (
            <>
              {profilePage === 1 && (
                <div className="space-create-profile">
                  <div className="space-create-profile-image"></div>
                  <div>
                    <GradientButton
                      text="Create Profile"
                      className="space-create-profile-btn"
                      onClick={() => {
                        setProfilePage(2);
                      }}
                    />

                  </div>
                </div>
              )}
              {profilePage === 2 && (
                <div className="onboarding-profile-wrapper">
                  <div className="profile-title build-profile">
                    Build Your profile
                  </div>
                  <div className="profile-content">
                    <div className="profile-content-wrapper">
                      <div className="basic-profile row">
                        <div className="left-panel col ">
                          <TextInput
                            label="First Name"
                            value={SAPUser.firstName}
                            onChange={(e) => {
                              handleProfileData("firstName", e);
                            }}
                          />
                          {SAPUser.firstName == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}
                          <TextInput
                            label="Last Name"
                            value={SAPUser.lastName}
                            onChange={(e) => {
                              handleProfileData("lastName", e);
                            }}
                          />
                          {SAPUser.lastName == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}
                          <TextInput
                            label="Email Id"
                            readOnly
                            value={SAPUser.email}
                          />
                          <TextInput
                            label="Offering Portfolio"
                            value={SAPUser.portfolio}
                            onChange={(e) => {
                              handleProfileData("portfolio", e);
                            }}
                          />
                          {SAPUser.portfolio == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}
                        </div>
                        <div className="center-panel col position-relative">
                          {(profilePictureFile == null ||
                            profilePictureFile == "" ||
                            profilePictureFile == undefined ||
                            profilePictureFile == "NA") && (
                              <div className="profile-picture-initials">
                                {SAPUser.firstName &&
                                  SAPUser.lastName &&
                                  SAPUser.firstName[0].toUpperCase() +
                                  "" +
                                  SAPUser.lastName[0].toUpperCase()}
                              </div>
                            )}
                          {profilePictureFile !== null &&
                            profilePictureFile !== "" &&
                            profilePictureFile !== undefined &&
                            profilePictureFile !== "NA" && (
                              <div
                                className="profile-picture-image"
                                style={{
                                  borderRadius: "50%",
                                  content: "url('" + profilePictureUrl + "')",
                                }}
                              ></div>
                            )}
                          <div
                            className="p-image"
                            onClick={uploadProfilePicture}
                            title="Upload Your Photo"
                          >
                            <div className="camera-outline">
                              <span className="cameraIcon"></span>
                            </div>
                            <input
                              className="file-upload"
                              id="uploadProfilePicture"
                              type="file"
                              onChange={(e) => {
                                profilePictureSelectHandler(e);
                              }}
                              onClick={(event) => {
                                event.target.value = null;
                              }}
                              accept="image/*"
                            />
                          </div>
                          {profilePictureFile !== null &&
                            profilePictureFile !== "" &&
                            profilePictureFile !== undefined &&
                            profilePictureFile !== "NA" && (
                              <div
                                className="d-image"
                                title="Remove Your Photo"
                                onClick={() => {
                                  removeProfilePicture();
                                }}
                              >
                                <div className="delete-outline onboarding-delete-outline">
                                  <span className="deleteIcon"></span>
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="right-panel col">
                          <TextInput
                            label="Offering"
                            value={SAPUser.offering}
                            onChange={(e) => {
                              handleProfileData("offering", e);
                            }}
                          />
                          {SAPUser.offering == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}
                          <TextInput
                            label="Location"
                            value={SAPUser.location}
                            onChange={(e) => {
                              handleProfileData("location", e);
                            }}
                          />
                          {SAPUser.location == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}
                          <TextInput
                            label="Industry"
                            value={SAPUser.industry}
                            onChange={(e) => {
                              handleProfileData("industry", e);
                            }}
                          />
                          {SAPUser.industry == "" && (
                            <div className="errorMsgText onboardingErrorMsg mt-0">
                              This field is required
                            </div>
                          )}

                          <SelectDropdown
                            label="Region/Geography"
                            options={regionsList}
                            className="col-md"
                            value={SAPUser.geographyId}
                            onChange={(e) => handleRegionChange(e)}
                          />

                        </div>
                      </div>
                    </div>
                    <div className="profile-bottom-content-wrapper">
                      <div className="profile-link"></div>
                      <div className="row px2">
                        {userProfileDataLocal &&
                          userProfileDataLocal.length > 0 &&
                          userProfileDataLocal
                            .filter((x) => x.category === "Basic Profile")
                            .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
                            .map((item, index) => {
                              return (
                                <div
                                  className="col mt-auto"
                                  key={`poermvn${index}`}
                                >
                                  <TextAreaInput
                                    className="more-about-me-input"
                                    label={item.value}
                                    maxLength="500"
                                    onChange={(e) => {
                                      handleFieldChange(e, item.value);
                                    }}
                                    value={item.answer}
                                  />
                                  {profilePageTwoSubmit &&
                                    (item.answer == "" ||
                                      item.answer == null ||
                                      item.answer == undefined) && (
                                      <div
                                        ref={scrollRef}
                                        className="errorMsgText onboardingErrorMsg position-absolute"
                                      >
                                        This field is required
                                      </div>
                                    )}
                                </div>
                              );
                            })}
                      </div>
                    </div>
                  </div>
                  <div className="extra-profile">
                    <button
                      className="arrow-btn back-arrow-btn"
                      onClick={previousPageHandler}
                    ></button>
                    <button
                      className="arrow-btn next-arrow-btn"
                      onClick={nextPageHandler}
                    ></button>
                  </div>
                </div>
              )}
              {profilePage === 3 && (
                <div className="onboarding-profile-wrapper ">
                  <div className="profile-title more-about-me">
                    More about me...
                  </div>
                  <div className="profile-content">
                    <div className="profile-content-wrapper">
                      <div className="profile-body">
                        <div className="more-about-me-content profile-form-body">
                          {userProfileDataLocal &&
                            userProfileDataLocal.length > 0 &&
                            userProfileDataLocal
                              .filter((x) => x.category === "About me")
                              .sort((a, b) =>
                                a.sequence > b.sequence ? 1 : -1
                              )
                              .map((item) => {
                                return (
                                  <>
                                    <TextInput
                                      className="col-12 mb-3"
                                      label={item.value}
                                      onChange={(e) => {
                                        handleFieldChange(e, item.value);
                                      }}
                                      value={item.answer}
                                      hasError={(e) => false}
                                    />
                                    {profilePageThreeSubmit &&
                                      (item.answer == "" ||
                                        item.answer == null ||
                                        item.answer == undefined) && (
                                        <div
                                          ref={scrollRef}
                                          className="errorMsgText onboardingErrorMsg"
                                        >
                                          This field is required
                                        </div>
                                      )}
                                  </>
                                );
                              })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="extra-profile">
                    <button
                      className="arrow-btn back-arrow-btn"
                      onClick={previousPageHandler}
                    ></button>
                    <button
                      className="arrow-btn next-arrow-btn"
                      onClick={nextPageHandler}
                    ></button>
                  </div>
                </div>
              )}
              {profilePage === 4 && (
                <div className="onboarding-profile-wrapper ">
                  <div className="profile-title more-about-me">
                    More about me...
                  </div>
                  <div className="profile-content">
                    <div className="profile-content-wrapper">
                      <div className="profile-body">
                        <div className="profile-form-body">
                          {userProfileDataLocal &&
                            userProfileDataLocal.length > 0 &&
                            userProfileDataLocal
                              .filter(
                                (x) => x.category === "Communities of Interest"
                              )
                              .map((item, index) => {
                                return (
                                  <div
                                    className="more-about-me-field"
                                    key={`poerhn${index}`}
                                  >
                                    <label className="">
                                      {item.value.split("&&")[0]}
                                    </label>
                                    <br />
                                    <label className="more-about-label-2 mb-2">
                                      {item.value.split("&&")[1]}
                                    </label>
                                    <div className="optionWrapper">
                                      {item.valueType === 2 &&
                                        JSON.parse(item.options).map(
                                          (option, index) => {
                                            var isChecked =
                                              item.answer &&
                                              item.answer.includes(option);
                                            return (
                                              <Checkbox
                                                key={`poncgafter${index}`}
                                                className="profile-checkbox-input"
                                                label={option}
                                                checked={isChecked}
                                                onChange={(e) =>
                                                  handleCheckBoxChange(
                                                    e,
                                                    item,
                                                    option,
                                                    0
                                                  )
                                                }
                                              />
                                            );
                                          }
                                        )}
                                      {item.valueType === 3 &&
                                        JSON.parse(item.options).map(
                                          (grp, parentIndex) => {
                                            return (
                                              <>
                                                <div className="optionGroup">
                                                  {grp.map(
                                                    (option, childIndex) => {
                                                      var isChecked =
                                                        item.answer &&
                                                        item.answer.includes(
                                                          option
                                                        );
                                                      return (
                                                        <Checkbox
                                                          key={`poyrsxz${childIndex}`}
                                                          className="profile-checkbox-input"
                                                          label={option}
                                                          checked={isChecked}
                                                          onChange={(e) =>
                                                            handleCheckBoxChange(
                                                              e,
                                                              item,
                                                              option,
                                                              parentIndex
                                                            )
                                                          }
                                                        />
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </>
                                            );
                                          }
                                        )}
                                      {profilePageFourSubmit &&
                                        item.valueType === 2 &&
                                        (item.answer == null ||
                                          item.answer == "" ||
                                          item.answer == undefined) && (
                                          <div
                                            className="errorMsgText onboardingErrorMsg"
                                            style={{ width: "100%" }}
                                          >
                                            Atleast select one.
                                          </div>
                                        )}
                                      {profilePageFourSubmit &&
                                        item.valueType === 3 &&
                                        (item.answer == null ||
                                          item.answer == "" ||
                                          item.answer == undefined) && (
                                          <div
                                            className="errorMsgText onboardingErrorMsg"
                                            style={{ width: "100%" }}
                                          >
                                            Atleast select one.
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="extra-profile">
                    <button
                      className="arrow-btn back-arrow-btn"
                      onClick={previousPageHandler}
                    ></button>
                    <button
                      className="arrow-btn next-arrow-btn"
                      onClick={nextPageHandler}
                    ></button>
                  </div>
                </div>
              )}


            </>
          )}

          {showPreLoadedSkillTrajectory && (
            < SkillTrajectory
              closeSkillTrajectory={exitSkillTrajectory}
              offeringId={parseInt(location.state.offeringId)}
              email={SAPUser.email}
              showSkillTrajectory={showSkillTrajectory}
            />
          )}

          <Modal
            show={showVideo}
            onHide={() => setShowVideo(false)}
            dialogClassName="video-player-model"
            aria-labelledby=""
            size="lg"
            centered
          >
            <Modal.Body>
              <div className="video-close-btn">
                <div
                  className="modal-close-btn"
                  onClick={() => {
                    setShowVideo(false);
                  }}
                ></div>
              </div>
              <div className="video-player-wrapper m-auto">
                <div className="video-decoration"></div>
                <div className="video-player-border">
                  <div className="video-player">
                    <VideoPlayer
                      //src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                      src={videoLink.length > 0 ? new URL(videoLink[0].link) : ""}
                      type="video/mp4"
                      isPlaying={true}
                    />
                  </div>
                </div>
                <div className="video-decoration custombottom"></div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showEligible}
            fullscreen={false}
            onHide={() => setShowEligible(false)}
            dialogClassName=""
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="eligibleModal"
          >
            <div
              className="modal-onboarding-close-btn modal-close-btn"
              onClick={() => {
                setShowEligible(false);
              }}
            ></div>
            <Modal.Body>
              <div className="eligible-text">
                {/* <span>You are currently not eligible for this program.</span> */}
                <span>{eligibleErrorMsg}</span>
              </div>

              <div className="eligible-btn">
                {!showMissionSelection && (
                  <button
                    className="eligibe-btn-size cdx-btn"
                    onClick={contactProgramManager}
                  >
                    Contact Program Team
                  </button>
                )}
              </div>
            </Modal.Body>
          </Modal>

          <CdxModal
            show={showAdditionalInfo}
            onHide={() => setShowAdditionalInfo(false)}
            onClose={() => setShowAdditionalInfo(false)}
            className="info-model"
          >
            <CdxModal.Header onClose={() => setShowAdditionalInfo(false)}>
              {additionalInfo.missionName}
            </CdxModal.Header>
            <CdxModal.Body>
              {additionalInfo && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: additionalInfo.additionalInfo,
                  }}
                />
              )}
            </CdxModal.Body>
          </CdxModal>

          <CdxModal
            show={showSkillPopup}
            onHide={() => {
              setSelectedMission(null);
              setShowSkillPopup(false);
            }}
            onClose={() => {
              setSelectedMission(null);
              setShowSkillPopup(false);
            }}
            className="info-model"
          >
            <CdxModal.Header
              onClose={() => {
                setSelectedMission(null);
                setShowSkillPopup(false);
              }}
            >
              Confirm Mission Selection
            </CdxModal.Header>
            <CdxModal.Body>
              {selectedMission && <div>
                You have selected '{selectedMission.missionName}'. Please click Register to continue with your selection, click Cancel if you wish to select a different mission.
              </div>
              }
            </CdxModal.Body>
            <CdxModal.Footer>
              <span
                onClick={() => {
                  setSelectedMission(null);
                  setShowSkillPopup(false);
                }}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#00AEFF",
                  marginRight: "20px",
                }}
              >
                Cancel
              </span>
              <GradientButton
                text="Register"
                className={
                  selectedMission ? "skill-btn" : "skill-btn disabled"
                }
                onClick={() => {
                  exitSkillTrajectory();
                }}
              />
            </CdxModal.Footer>
          </CdxModal>

          <MissionDirectors
            show={showMissionDirectors}
            onClose={setShowMissionDirectors}
            deanData={deanData}
            coachList={coachList}
            industryList={industryList}
            offeringList={offeringList}
            geographyList={geographyList}
            offeringId={offeringId}
          />
        </div>
      )}
      <TourSlide
        startTour={startTour}
        stopTour={setStartTour}
        tourItem={"onboarding"}
      />
    </>
  );
}
